export { Button, type ButtonProps } from '@/shared/ui/shadcn/button';
